import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { Link } from 'gatsby';
import { Flex, Tag, Text } from '../../../components/blocks';

type Props = {
  img?: string;
  url?: string;
  title?: string;
  tags?: string;
};

const Img = styled.img`
  border-radius: ${({ theme }) => `${theme.radii.s} 0 0 ${theme.radii.s}`};
`;

const Root = styled(Link)`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: ${({ theme }) => theme.spaces.m};
  align-items: center;
  border: 1px solid ${({ theme }) => theme.borderColors.transparent};
  padding: ${({ theme }) => theme.spaces.s};
  background-color: ${({ theme }) => theme.backgroundColors.white};
  border-radius: ${({ theme }) => theme.radii.s};
  transition-duration: ${({ theme }) => theme.transitions.fast};

  &:hover {
    border: 1px solid ${({ theme }) => theme.borderColors.primary};
  }
`;

export const Related: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <Root to={props.url}>
      <Img src={props.img} width="100%" height="auto" />
      <Flex flexDirection="column" gap={theme.spaces.s} alignItems="flex-start">
        <Text as="h3" lineHeight="m" size="s" fontWeight="bold">
          {props.title}
        </Text>
        {props.tags?.length > 0 && (
          <Tag
            color={
              props.tags == '導入事例'
                ? 'primary'
                : props.tags == 'セミナーレポート'
                ? 'green'
                : props.tags == 'イベントレポート'
                ? 'secondary'
                : 'default'
            }
          >
            {props.tags}
          </Tag>
        )}
      </Flex>
    </Root>
  );
};
